import { gozokiApiWithAuth } from '../gozokiApi'

export const downloadPeriodAccountingKpiXlsx = async ({
  dateStart,
  dateEnd,
}: {
  dateStart: string
  dateEnd: string
}) => {
  const response = await gozokiApiWithAuth.get(
    `/stores/get-period-accounting-kpis-xlsx/${dateStart}/${dateEnd}`, // 'AAAA-MM-DD'
    {
      responseType: 'blob',
    },
  )

  return response
}
